export default "__VITE_ASSET__dG$5QQEC__"